export const getTestEventData = () => [
    {
        type: 'Cultural Celebration',
        title: 'Pop-up Meditation: The Practice of Zazen',
        location: 'Meet at Information Desk',
        displayTime: '10:30',
        displayTimePeriod: 'am'
    },
    {
        type: 'Exhibition Tour',
        title: `Painting is my Everything: Art from India's Mithila Region`,
        location: 'Meet at Education Studios',
        displayTime: '11:30',
        displayTimePeriod: 'am'
    },
    {
        type: 'Workshop',
        title: `Lunar Society: Craft Night with Emily Gui
        Mochi Pounding`,
        location: 'Meet at Samsung Hall',
        displayTime: '01:00',
        displayTimePeriod: 'pm'
    },
    {
        type: 'Architectural Tour',
        title: 'Storytelling! The Wicked, The Willy, The Wise',
        location: 'Meet at South Court',
        displayTime: '01:30',
        displayTimePeriod: 'pm'
    },
    {
        type: 'Workshop',
        title: `Traditional Bamboo Workshop with Tanabe Chikunasai IV`,
        location: 'Meet at Information Desk',
        displayTime: '02:30',
        displayTimePeriod: 'pm'
    },
    {
        type: 'Cultural Celebration',
        // title: 'Rhino Club: Watercolor Bookmarks',
        title: 'Mochi Pounding (Omochitsuki)',
        location: 'Meet at Samsung Hall',
        displayTime: '04:30',
        displayTimePeriod: 'pm'
    }
];

export const getTestEventTimes = seconds => {
    const times = [];

    const hour = pad(new Date().getHours());
    const month = getMonth(new Date().getMonth());
    const date = pad(new Date().getDate());
    const year = new Date().getFullYear();

    for (let hh = hour; hh < hour + 1; hh++) {
        for (let mm = 0; mm < 60; mm++) {
            if (!seconds) {
                const time = new Date(
                    `${month} ${date} ${year} ${pad(hh)}:${pad(mm)}:00`
                );
                times.push(time);
            } else {
                for (let ss = 0; ss < 60; ss += seconds) {
                    const time = new Date(
                        `${month} ${date} ${year} ${pad(hh)}:${pad(mm)}:${pad(
                            ss
                        )}`
                    );
                    times.push(time);
                }
            }
        }
    }

    // for (let hh = hour; hh < hour + 1; hh++) {
    //     for (let mm = 0; mm < 60; mm++) {
    //         for (let ss = 0; ss < 60; ss += 5) {
    //             count = count > 5 ? 0 : count;
    //             times.push(getFullTime());
    //             count++;

    //             function getFullTime() {
    //                 return new Date(
    //                     `${month} ${date} ${year} ${pad(hh)}:${pad(mm)}:${pad(
    //                         ss
    //                     )}`
    //                 );
    //             }
    //         }
    //     }
    // }

    return times;

    function pad(n) {
        return n < 10 ? 0 + n.toString() : n;
    }

    function getMonth(n) {
        const months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec'
        ];

        return months[n];
    }
};

/*
|--------------------------------------------------------------------------
| TIME FNS
|--------------------------------------------------------------------------
*/

// function getTime() {
//     const fullTime = getFullTime();
//     const time = `${pad(new Date(fullTime).getHours())}:${pad(
//         new Date(fullTime).getMinutes()
//     )}`;

//     return get24HourFormat(time);
// }

// function getTimePeriod() {
//     const fullTime = getFullTime();
//     return new Date(fullTime).getHours() > 11 ? 'pm' : 'am';
// }

// function get24HourFormat(time) {
//     return time > 12 ? time - 12 : time;
// }
